import Vue from 'vue';
import { getClientVersion, compareVersion } from '@/utils/compareVersion';
import { getApp } from '@/utils/util';

/**
 * 转换userInfo数据
 * < 1.8可用字段
 * {
    "icon_url": "",
    "account_type": 0,
    "forbid_reason": "",
    "gender": 0,
    "level": 0,
    "login_type": 0,
    "follow_status": 0,
    "description": "",
    "recommend_type": 0,
    "privilege": 0,
    "uid": 0,
    "identification": "",
    "vip_type": 0,
    "scheme_url": "",
    "phone": "",
    "nick_name": "",
    "exp": 0,
    "status": 0,
    "forbid_time": 0
 * }
 * 其余字段必须 >= 1.8
 * @param originUserInfo
 * @returns {*}
 */

export function transferUserInfo(originUserInfo) {
  let userInfo = {};
  let tempUserInfo;
  if (!originUserInfo) return {};
  if (typeof originUserInfo === 'string') {
    tempUserInfo = JSON.parse(originUserInfo);
  } else {
    tempUserInfo = originUserInfo;
  }
  if (Vue.Native.Platform === 'ios') {
    const userAgent = getApp()?.$options?.$superProps?.httpHeaderInfo?.['User-Agent'];
    if (userAgent) {
      const clientVersion = getClientVersion(userAgent);
      const flag = compareVersion('1.8', clientVersion);
      if (flag >= 0) {
        userInfo = {
          ...tempUserInfo,
          uid: Number(tempUserInfo.uid) || 0,
          privilege: Number(tempUserInfo.privilege) || 0,
          forbid_time: Number(tempUserInfo.forbid_time) || 0,
          scheme_url: tempUserInfo.schemeURL,
        };
      } else {
        userInfo = {
          ...tempUserInfo,
          uid: Number(tempUserInfo.uid) || 0,
          privilege: Number(tempUserInfo.privilege) || 0,
          forbid_time: Number(tempUserInfo.forbid_time) || 0,
        };
      }
    } else {
      userInfo = {
        ...tempUserInfo,
        uid: Number(tempUserInfo.uid) || 0,
        privilege: Number(tempUserInfo.privilege) || 0,
        forbid_time: Number(tempUserInfo.forbid_time) || 0,
      };
    }
  } else if (Vue.Native.Platform === 'android') {
    userInfo = {
      ...tempUserInfo,
      uid: Number(tempUserInfo.uid) || 0,
      privilege: Number(tempUserInfo.privilege) || 0,
      forbid_time: Number(tempUserInfo.forbid_time) || 0,
    };
  }
  return {
    ...userInfo,
    __is_transfer: true,
  };
}
